import { render } from "./Block.vue?vue&type=template&id=5814ee38&bindings={\"delay\":\"props\",\"showBlock\":\"data\",\"timer\":\"data\",\"reactionTime\":\"data\",\"startTimer\":\"options\",\"stopTimer\":\"options\"}"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"

import "./Block.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script